import React from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { ProgressSpinner } from 'primereact/progressspinner';

const BarDistributionChart = ({ TITLE, DATA }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const chartOptions = {
    animationEnabled: true,
    backgroundColor: 'transparent',
    theme: isDark ? 'dark2' : 'light2',
    title: {
      text: '',
    },
    legend: {
      verticalAlign: 'top',
      reversed: false,
      cursor: 'pointer',
      fontSize: 14,
      fontFamily: 'Mukta, Saira, Roboto, sans-serif',
      fontColor: isDark ? '#f1f5f9' : '#1e293b',
    },
    axisX: {
      valueFormatString: 'MMM DD HH',
      labelFontColor: isDark ? '#cbd5e1' : '#475569',
      lineColor: isDark ? 'rgba(255, 255, 255, 0.15)' : '#cbd5e1',
      gridColor: isDark ? 'rgba(255, 255, 255, 0.08)' : '#f1f5f9',
    },
    axisY: {
      title: TITLE,
      titleFontColor: isDark ? '#f1f5f9' : '#1e293b',
      labelFontColor: isDark ? '#cbd5e1' : '#475569',
      lineColor: isDark ? 'rgba(255, 255, 255, 0.15)' : '#cbd5e1',
      gridColor: isDark ? 'rgba(255, 255, 255, 0.08)' : '#e2e8f0',
      minimum: 0,
    },
    toolTip: {
      shared: true,
      backgroundColor: isDark ? '#162328' : '#ffffff',
      fontColor: isDark ? '#f1f5f9' : '#1e293b',
      borderColor: isDark ? 'rgba(255, 255, 255, 0.2)' : '#cbd5e1',
    },
    data: DATA,
  };

  const isLoading = false;

  return (
    <div style={{ width: '100%' }}>
      {isLoading && (
        <ProgressSpinner
          style={{
            width: '50px',
            height: '50px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '1',
          }}
        />
      )}
      <div className="box-dash">
        <Paper elevation={5} sx={{ p: 2.5, height: '100%' }}>
          <Typography variant="h6" fontWeight={700} sx={{ mb: 1, color: 'text.primary' }}>
            {TITLE}
          </Typography>
          <CanvasJSReact.CanvasJSChart options={chartOptions} />
        </Paper>
      </div>
    </div>
  );
};

BarDistributionChart.propTypes = {
  TITLE: PropTypes.string,
  DATA: PropTypes.array,
};

export default BarDistributionChart;
